/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { actions as userActions, selectors as userSelectors } from '../../redux/ducks/user';

import ExpiredToken from '../views/ExpiredToken';
import ResetForgottenPassword from './ResetForgottenPassword.controller';
import ConfirmChangeEmail from './ConfirmChangeEmail.controller';
import EmailVerificationSuccess from './EmailVerificationSuccess';

import AppNavStep from '../../components/appNav/AppNavStep';
import AppHeader from '../../applicationFrame/AppHeader';

import SessionService from '../../../apiServices/SessionService';
import { UserMetricsProfile } from '../../../utilities/UserMetrics';
import UserModel from '../../../models/UserModel';
import tokenTypes from '../../../constants/tokenTypes';

function getUrlTokenType(searchLocation) {
  if (searchLocation.indexOf(tokenTypes.forgotPassword) > -1) {
    return tokenTypes.forgotPassword;
  } else if (searchLocation.indexOf(tokenTypes.changeEmail) > -1) {
    return tokenTypes.changeEmail;
  } else {
    return '';
  }
}

function mapStateToProps(state) {
  return {
    isUserLoaded: userSelectors.isUserLoaded(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateUser: (userData) => {
      dispatch(userActions.updateUser(userData));
    },
  };
}

class TokenViews extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      tokenType: '',
      token: '',
      isMfaEnabled: false,
      isExpired: false,
      isLoaded: false,
    };
  }

  UNSAFE_componentWillMount() {
    const token = _.get(this.props, 'match.params.token', '');
    const urlTokenType = this.props.location.search;

    SessionService.get(token, (apiError, session) => {
      const userData = session.userData();
      const user = new UserModel(userData);
      if (!apiError) {
        if (!this.props.isUserLoaded) {
          UserMetricsProfile.init(user.data.cuid);
          this.props.updateUser(userData);
        }

        this.setState({
          tokenType: session.tokenType(),
          userId: userData.id,
          token,
          // isMfaEnabled: session.requiresMfa(),
          isMfaEnabled: user.isMfaEnabled(),
          isLoaded: true,
        });
      } else {
        this.setState({
          tokenType: getUrlTokenType(urlTokenType),
          isExpired: true,
          isLoaded: true,
        });
      }
    });
  }

  render() {
    if (this.state.isExpired) {
      return <ExpiredToken tokenType={this.state.tokenType} />;
    }

    if (!this.state.isLoaded) {
      return null;
    }

    switch (this.state.tokenType) {
      case tokenTypes.forgotPassword:
        return <ResetForgottenPassword {...this.state} />;
      case tokenTypes.changeEmail:
        return <ConfirmChangeEmail {...this.state} />;
      case tokenTypes.verifyEmail:
        return <EmailVerificationSuccess {...this.state} />;
      default:
        return (
          <div>
            <AppHeader>
              <AppNavStep />
            </AppHeader>
          </div>
        );
    }
  }
}
TokenViews.propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
  updateUser: PropTypes.func,
  isUserLoaded: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(TokenViews);
